"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMessage = void 0;
var lite_1 = __importDefault(require("mime/lite"));
var path_1 = __importDefault(require("path"));
var react_1 = __importDefault(require("react"));
var Text_1 = require("./Text");
var FileMessage = function (props) {
    if (!props.file) {
        return null;
    }
    var _a = props.file, url = _a.url, title = _a.title, storage = _a.storage, text = _a.text;
    var extension = '';
    try {
        var validUrl = new URL(url);
        extension = validUrl.pathname;
    }
    catch (error) {
        // Try using path.extname since url might be relative.
        extension = path_1.default.extname(url);
    }
    var mime = lite_1.default.getType(extension);
    if (text) {
        return react_1.default.createElement(Text_1.Text, { text: text, markdown: true, escapeHTML: props.escapeTextHTML });
    }
    if (storage === 'local') {
        return (react_1.default.createElement("div", { className: 'bpw-file-message' },
            react_1.default.createElement("div", null,
                title,
                " (local)")));
    }
    if (mime.includes('image/')) {
        return (react_1.default.createElement("a", { href: url, target: '_blank' },
            react_1.default.createElement("img", { src: url, title: title })));
    }
    else if (mime.includes('audio/')) {
        return (react_1.default.createElement("audio", { controls: true },
            react_1.default.createElement("source", { src: url, type: mime })));
    }
    else if (mime.includes('video/')) {
        return (react_1.default.createElement("video", { controls: true },
            react_1.default.createElement("source", { src: url, type: mime })));
    }
    else {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, "File: "),
            react_1.default.createElement("a", { href: url, target: '_blank' }, title || url)));
    }
};
exports.FileMessage = FileMessage;
